module.exports = "/_next/static/images/content-badge-tier-2-2667ae4b0e16967982d613dcf91f2b70.png";